module.exports = __webpack_public_path__ + "img/jersey.6aac5c48.png";